import { render, staticRenderFns } from "./commonNotice.vue?vue&type=template&id=b8323c24&scoped=true"
import script from "./commonNotice.vue?vue&type=script&lang=js"
export * from "./commonNotice.vue?vue&type=script&lang=js"
import style0 from "./commonNotice.vue?vue&type=style&index=0&id=b8323c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8323c24",
  null
  
)

export default component.exports